import { Row, Col, Typography } from 'antd';
import { StudentType } from './types';
import StudentTable from './StudentTable';

type Props = {
  studentInfo: StudentType;
  getAllStudentFunction: Function;
}

function StudentSingle(props: Props) {
  const { studentInfo, getAllStudentFunction } = props;
  const { timePeriodName, className } = studentInfo;

  return (
    <Row gutter={[8, 0]} justify="center">
      <Col>
        <Typography.Title level={3}>
          {`${timePeriodName} - ${className}`}
        </Typography.Title>
      </Col>

      <Col span={24}>
        <StudentTable
          studentArray={[studentInfo]}
          fetchStudentFunction={getAllStudentFunction}
        />
      </Col>
    </Row>
  )
}

export default StudentSingle;